export class RequestShipmentArrivalPostModel {
  public RequestId?: number;
  public ArrivalDate?: Date;
  public IsComingFromIntegration?: boolean;
  public ManuelEntryReason?: string;
}

export class RequestShipmentArrivalPutModel {
  public id?: number;
  public RequestId?: number;
  public ArrivalDate?: Date;
  public IsComingFromIntegration?: boolean;
  public ManuelEntryReason?: string;
  public updatedBy?: string;
  public updatedDate?: Date;
}
